import Vue from 'vue';

import { END_POINTS } from '@/enums';

import API from './index';

const END_POINT = END_POINTS.FORMS;

export default {
  async getFormStores(): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/stores`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/stores`, err.response);
      throw err.response;
    }
  },
  async submitContactUs(requestModel: ContactUsRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/contact-us`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/contact-us`, err.response);
      throw err.response;
    }
  },
  async submitGiftCardBalanceCheck(requestModel: GiftCardBalanceCheckRequest): Promise<number> {
    try {
      return (await API.post(`${END_POINT}/gift-card-balance`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/gift-card-balance`, err.response);
      throw err.response;
    }
  },
  async submitFoundationApplication(requestModel: FoundationApplicationRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/foundation-application`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/foundation-application`, err.response);
      throw err.response;
    }
  },
  async submitFreeSubs(requestModel: FreeSubsRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/free-subs`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/free-subs`, err.response);
      throw err.response;
    }
  },
  async submitSweepstakes(requestModel: SweepstakesRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/sweepstakes`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/sweepstakes`, err.response);
      throw err.response;
    }
  },
  async submitWSA(requestModel: WSARequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/wsa`, requestModel)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/wsa`, err.response);
      throw err.response;
    }
  }
}
